var React = require('react');

function Frame (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"24","width":"293","height":"186","stroke":"#231F20","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M147.5 4.2551C148.536 4.2551 149.375 3.41449 149.375 2.37755C149.375 1.34061 148.536 0.5 147.5 0.5C146.464 0.5 145.625 1.34061 145.625 2.37755C145.625 3.41449 146.464 4.2551 147.5 4.2551Z","fill":"#231F20","key":1}),React.createElement("path",{"d":"M110 23.5L146.094 2.37756","stroke":"#231F20","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M185 23.5L148.906 2.37756","stroke":"#231F20","strokeLinecap":"round","key":3})]);
}

Frame.defaultProps = {"width":"294","height":"211","viewBox":"0 0 294 211","fill":"none"};

module.exports = Frame;

Frame.default = Frame;
